// extracted by mini-css-extract-plugin
module.exports = {"label":"YehSwitch_label__274Jh"};